export default "__VITE_ASSET__Tq3jJiju__"